import React, { useState, useEffect } from "react";
import SearchPage from "../views/firstPage/SearchPage";
import { Container, Row, Col } from "react-bootstrap";
import LoginModal from "../views/firstPage/LoginModal";
import RegistrModal from "../views/firstPage/RegistrModal";
import { Link } from "react-router-dom";
import "../assets/style/styles.scss";
import { withRouter } from "react-router";
import { fire } from "../firebase/config";
function Header(props) {
  const [menuToggle, setMenuToggle] = useState(false);
  const [popUp, setPopUp] = useState("");
  const [user, setUser] = useState(false);
  const [userInfo, setUserInfo] = useState();
  const [userDrop, setUserDrop] = useState(false);
  useEffect(() => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        setUser(true);
        fire
          .database()
          .ref("/users/" + user.uid)
          .once("value")
          .then((snapshot) => {
            let res = snapshot.val();

            setUserInfo(res);
          });
        localStorage.setItem("user", user.uid);
        return;
      } else {
        setUser(false);
        localStorage.removeItem("user");
        return;
      }
    });
    return () => {};
  }, [user]);

  const popUpClose = () => {
    setPopUp("");
  };

  return (
    <header
      className={props.location.pathname == "/" ? "header" : "header_tmp"}
      id="header"
    >
      <Container>
        <div class={menuToggle ? "header-back__active" : "header__back"}></div>
        <nav class={menuToggle ? "header-nav__active" : "header__nav"}>
          <div class="header__border"></div>
          <div class="header-nav__items d-flex">
            <div class="header-nab__item d-flex">
              <Link to="/deal">БЕЗОПАСНАЯ СДЕЛКА</Link>
              <Link to="">КАК ЭТО РАБОТАЕТ?</Link>
              <Link to="">ОПЛАТА И УСЛОВИЯ</Link>
              <Link to="/rating">ОТЗЫВЫ</Link>
            </div>
            <div class="header-nab__item d-flex">
              <Link to="/partner">ПАРТНЕРКА</Link>
              <Link to="/rating">РЕЙТИНГ ПРОДАВЦОВ</Link>
              <Link to="/service">СЕРВИС</Link>
              <Link to="">ИНФОРМАЦИЯ</Link>
            </div>
          </div>
        </nav>
        <div class="header__wrapper">
          <Row>
            <div class="col-12 col-sm-10 m-auto col-md-4 col-lg-3">
              <div class="header__head d-flex">
                <div
                  class={
                    menuToggle
                      ? "header-burder__active header__burder header-burder"
                      : "header__burder header-burder"
                  }
                  onClick={() => {
                    setMenuToggle(() => {
                      return !menuToggle;
                    });
                  }}
                >
                  <span class="header-burder__btn"></span>
                </div>

                <div class="header__logo"></div>
              </div>
            </div>
            <div class="col-md-9 col-10 m-auto">
              <div class="header__log header-log d-flex">
                <Link className="header-log__new log-new d-flex" to="/create">
                  <div class="log-new__img d-flex">
                    <img src="/img/header-new.svg" alt="img" />
                  </div>

                  <div class="log-new__text d-flex">Новое обьявление</div>
                </Link>
                {user ? (
                  <div class="d-flex">
                    <div class="more-boxmsg d-flex">
                      <Link to="/message">
                        <div class="header-log__massage">
                          <div class="image"></div>
                        </div>
                      </Link>
                      <a href="#" id="modalpopup">
                        <div class="header-log__security">
                          <div class="image"></div>
                        </div>
                      </a>
                    </div>

                    <a  class="user">
                      <button
                        class={
                          userDrop
                            ? "search-item__vp1 correctText drop-active"
                            : "search-item__vp1 correctText"
                        }
                        onClick={() => {
                          setUserDrop(() => !userDrop);
                        }}
                      >
                        {userInfo ? userInfo.name : "..."}
                        <div class="user-name__online"></div>

                        <div class="drop-box">
                          <div class="dropdown-child">
                            <a  class="balance d-flex">
                              <div class="balance__hm">Баланс</div>
                              <div class="balance__count">
                                {userInfo ? userInfo.balance : "..."}$
                              </div>
                              <div class="balance__line"></div>
                            </a>
                            <div class="drop-more">
                              <Link class="drop-more__item" to="/user">
                                Личный кабинет
                              </Link>

                              <a href="#" class="drop-more__item">
                                Мой кошелек
                              </a>
                              <Link class="drop-more__item" to="/myAds">
                                МОИ ОБЪЯВЛЕНИЯ
                              </Link>
                              <Link class="drop-more__item" to="/partner">
                                ПАРТНЕРКА
                              </Link>

                              <a href="#" class="drop-more__item">
                                ИЗБРАННОЕ
                              </a>
                              <Link class="drop-more__item" to="/alert">
                                ОПОВЕЩЕНИЕ
                              </Link>
                            </div>
                            <div class="drop__exit">
                              <a
                                
                                class="drop-exit__btn"
                                onClick={() => {
                                  fire.auth().signOut();
                                }}
                              >
                                Выход
                                <div class="balance__line2"></div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </button>
                    </a>
                  </div>
                ) : (
                  <div class="header-log__sign header-log-sign d-flex">
                    <a class="header-log-sign__up sign-up d-flex" href="#">
                      <div class="sign-up__img d-flex">
                        <img src="/img/header-user.svg" alt="img" />
                      </div>
                      <div
                        onClick={() => setPopUp("register")}
                        class="sign-up__text d-flex"
                        id="upbtn"
                      >
                        Регистрация
                      </div>
                    </a>
                    <a class="header-log-sign__in sign-in d-flex" href="#">
                      <div class="sign-in__img d-flex">
                        <img src="/img/header-login.svg" alt="img" />
                      </div>
                      <div
                        onClick={() => setPopUp("login")}
                        class="sign-in__text d-flex"
                        id="inbtn"
                      >
                        Вход
                      </div>
                    </a>
                  </div>
                )}
              </div>
            </div>
          </Row>
          {props.location.pathname == "/" ? <SearchPage /> : null}
        </div>
      </Container>
      {popUp != "" ? (
        popUp === "login" ? (
          <LoginModal closeFu={popUpClose} />
        ) : (
          <RegistrModal closeFu={popUpClose} />
        )
      ) : null}
    </header>
  );
}

export default withRouter(Header);
